export default __webpack_public_path__ + "static/media/tituloEN.fed9299a.png";